import { isDefined } from '@sgme/fp';
import { useSwitcher } from 'hooks/useSwitcher';
import { useUnderlyingContext } from 'hooks/useUnderlyingContext';
import type { UnderlyingCodeType } from 'models/underlying/base';

type Underlying = {
  bloombergTickerCode?: string;
  isin?: string;
  reutersCode?: string;
  bloombergComposite?: string;
  micCode?: string;
};
export const useCodeTypeSwitcher = (underlyings: Underlying[] = []) => {
  const { codeTypes } = useUnderlyingContext();
  const filteredCodeTypes = codeTypes.filter(c =>
    underlyings.some(u => {
      switch (c) {
        case 'Bloomberg':
          return isDefined(u.bloombergTickerCode);
        case 'BloombergComposite':
          return isDefined(u.bloombergComposite);
        case 'Isin':
          return isDefined(u.isin);
        case 'Reuters':
          return isDefined(u.reutersCode);
        case 'MicCode':
          return isDefined(u.micCode);
      }
      return false;
    }),
  );

  return useSwitcher<UnderlyingCodeType>(filteredCodeTypes);
};
